module.exports = __webpack_public_path__ + "static/media/img01.e2091a30.webp";